/**
 * The seven questions people ask before they start, each opening to its
 * answer.
 *
 * Words (en/es): landing.faq.*.
 *
 * @module Faq
 */

import React from 'react';
import { useTranslation } from '@/shared/hooks/useTranslation';

/** One question and its answer (translation keys). */
interface Question {
  /** The question's key. */
  id: string;
  /** The question. */
  q: string;
  /** The answer. */
  a: string;
}

/** The questions, in order. */
const QUESTIONS: readonly Question[] = [
  { id: 'weather', q: 'landing.faq.weather.q', a: 'landing.faq.weather.a' },
  { id: 'guessing', q: 'landing.faq.guessing.q', a: 'landing.faq.guessing.a' },
  { id: 'nag', q: 'landing.faq.nag.q', a: 'landing.faq.nag.a' },
  { id: 'stop', q: 'landing.faq.stop.q', a: 'landing.faq.stop.a' },
  { id: 'private', q: 'landing.faq.private.q', a: 'landing.faq.private.a' },
  { id: 'where', q: 'landing.faq.where.q', a: 'landing.faq.where.a' },
  { id: 'app', q: 'landing.faq.app.q', a: 'landing.faq.app.a' },
];

/** The questions. */
export const Faq: React.FC = () => {
  const { reactTranslate: t } = useTranslation();
  return (
    <section className="px-4 py-12 md:px-8 md:py-20">
      <div className="mx-auto max-w-3xl">
        {QUESTIONS.map(({ id, q, a }) => (
          <details key={id} className="border-b py-3">
            <summary className="cursor-pointer font-bold">{t(q)}</summary>
            <p className="mt-2 text-muted-foreground">{t(a)}</p>
          </details>
        ))}
      </div>
    </section>
  );
};
